import http from '@/utils/request';

/**
 * 二级分类（与后端 SubCategory 枚举保持一致）
 */
export enum SubCategory {
  MiniProgramPrivacy = 1,
  AppStorePrivacy = 2,
  NetworkSecurityClue = 3,
}

export const SUB_CATEGORY_LABEL: Record<SubCategory, string> = {
  [SubCategory.MiniProgramPrivacy]: '小程序个保',
  [SubCategory.AppStorePrivacy]: 'APP个保',
  [SubCategory.NetworkSecurityClue]: '网络安全线索',
};

/**
 * 群聊会话记录（t_wecom_chat）
 */
export interface WecomChat {
  id: number;
  chatid: string;
  chatType: 'group' | 'single' | string;
  name: string | null;
  subCategory: number | null;
  lastFrom: string | null;
  lastMsgAt: string | null;
  lastMsgText: string | null;
  remark: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface WecomChatListResult {
  list: WecomChat[];
  total: number;
  page: number;
  pageSize: number;
}

export interface WecomChatListParams {
  page?: number;
  pageSize?: number;
  keyword?: string;
  chatType?: 'group' | 'single';
  subCategory?: number;
}

export interface UpdateWecomChatPayload {
  id: number;
  name?: string | null;
  subCategory?: number | null;
  remark?: string | null;
}

export const fetchWecomChatList = (params: WecomChatListParams) =>
  http.get<unknown, WecomChatListResult>('/wecom-chat/list', { params });

export const updateWecomChat = (payload: UpdateWecomChatPayload) =>
  http.post<unknown, WecomChat>('/wecom-chat/update', payload);

export const deleteWecomChat = (id: number) =>
  http.post<unknown, { id: number }>('/wecom-chat/delete', { id });
